module.exports = __webpack_public_path__ + "img/landing27.06b78f64.jpg";